// extracted by mini-css-extract-plugin
export default {"wrapper":"_33d92c76","iconWrapper":"_4a2589dd"};